import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './KALogo.module.scss';
import LogoImage from 'images/ka-logo-black.png';
import Image from 'Pages/Home/Components/Atoms/Image';

export default function KALogo() {
  return <Image src={LogoImage} className={Styles['ka-logo-image']} />;
}
